import api from './api';

/**
 * Service for managing page background images
 *
 * API Endpoints (from CMS Backend):
 * - GET    /api/admin/page-backgrounds              - Get all backgrounds
 * - GET    /api/admin/page-backgrounds/{id}         - Get background by ID
 * - GET    /api/admin/page-backgrounds/page/{page}  - Get background by page
 * - PUT    /api/admin/page-backgrounds/{id}         - Update background
 *
 * Note: There are exactly 2 backgrounds - 'home' and 'product-listing'.
 *       No create/delete operations - update only.
 *       Backgrounds cannot be deactivated (isActive is always true).
 */

const API_PATH = '/api/admin/page-backgrounds';

const pageBackgroundService = {
  // ============ Read Operations ============

  /**
   * Get all page backgrounds
   * @returns {Promise} Axios promise with array of 2 PageBackground objects
   */
  getAll: () => {
    return api.get(API_PATH);
  },

  /**
   * Get a single background by ID
   * @param {string} id - Background UUID
   * @returns {Promise} Axios promise with PageBackground object
   */
  getById: (id) => {
    return api.get(`${API_PATH}/${id}`);
  },

  /**
   * Get background for a specific page
   * @param {string} page - Page identifier ('home' or 'product-listing')
   * @returns {Promise} Axios promise with PageBackground object
   */
  getByPage: (page) => {
    return api.get(`${API_PATH}/page/${page}`);
  },

  // ============ Update Operations ============

  /**
   * Update a background
   * @param {string} id - Background UUID
   * @param {Object} data - Update data
   * @param {string} data.imageUrl - Required, max 500 chars, valid URL
   * @param {string} [data.description] - Optional, max 1000 chars
   * @returns {Promise} Axios promise with updated PageBackground object
   */
  update: (id, data) => {
    return api.put(`${API_PATH}/${id}`, data);
  },
};

export default pageBackgroundService;
